<template>
<!-- eslint-disable vue/valid-v-slot -->
    <v-dialog max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="show" persistent >
      <v-card class="rounded-card">
        <v-system-bar color="teal" height="50px">
           <span class="headline font-weight-bold ms-2"> {{tmr.Id ? this.$i18n.t('Edit TMR') + " " + tmr.code : this.$i18n.t('New TMR')}}</span>
        </v-system-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs8 sm6>
              <v-text-field :label="$t('TMR Code')" v-model="tmr.code" :disabled="!isNewTmr"></v-text-field>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm2 ></v-flex>
            <v-flex xs4 sm4>
              <v-switch v-model="active" :label="$t('Active')" color="primary" class="ps-3"></v-switch>
            </v-flex>
          </v-layout>
            <v-text-field :label="$t('TMR Name')" v-model="tmr.name"></v-text-field>
            <v-select flat class="pe-1" :items="dropdown_feeds" v-model="tmr.premixkey"
                :label="$t('Premix of type')" editable :hint="$t('select a feed name that this premix makes')">
                <template v-slot:selection="{ item }">
                  <span :class="{'grey--text text--darken-1': item.value==''}">{{item.text}}</span>
                </template>
            </v-select>
          <v-layout wrap>
            <v-flex xs4 sm4>
              <v-text-field :label="$t('Version')" v-model.number="tmr.version" :hint="$t('Version number of this TMR')"></v-text-field>
            </v-flex>
            <v-flex xs1 sm2 ></v-flex>
            <v-flex xs7 sm6>
              <v-text-field :label="$t('Last Modified')" v-model="modifiedDate" disabled></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <!-- feeds table -->
        <v-data-table
          :headers="headers"
          :items="tmr.feeds"
          item-key="id"
          disable-pagination
          fixed-header
          disable-sort
          hide-default-footer
          :no-data-text="$t('Add Feeds to this TMR')"
          class="ms-3"
          >
            <template v-slot:top>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <span class="ms-5">{{$t('Feeds')}}: </span>
                  <v-spacer></v-spacer>
                  <v-btn class="mx-10 px-1 add-btn" small color="primary lighten-1" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                  <span class="mx-2" color="primary">{{$t('Add Feed')}}</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{formTitle}}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-if="editedItem.code" v-model="editedItem.code" :label="$t('Feed Code')"></v-text-field>
                          <v-select v-if="!editedItem.code" flat class="pe-1" :items="dropdown_feeds2"
                            v-on:change="fillFeedValues"
                            :label="$t('Feed Code')" editable :hint="$t('select a feed to add')">
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.name" :label="$t('Feed Name')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" >
                          <v-text-field v-model.number="editedItem.qty" ref="qtyField" :label="$t('Quantity per dose _Kg')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" >
                          <v-text-field v-model.number="editedItem.tolerance" :label="$t('Tolerance_Kg')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" >
                          <!-- <v-switch v-model="editedItem.manLoad" label="Manual Load"></v-switch> -->
                          <v-tooltip top>
                            <template v-slot:activator="{on}">
                              <v-icon :color="editedItem.manLoad ? 'orange darken-1' : 'grey'"
                                          v-on="on" class="pt-3 pl-4"
                                          @click="editedItem.manLoad = !editedItem.manLoad">
                                mdi-hand-right</v-icon>
                            </template>
                              <span>{{$t('Select if Item should be Loaded Manually')}}</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-tooltip top v-if="tmrId">
                      <template v-slot:activator="{on}">
                        <v-btn icon large color="primary" v-on="on" @click.stop="deleteFeedItem">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('Remove this feed from TMR')}}</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-btn icon color="primary" v-on="on" @click.stop="closeFeedEditor">
                          <v-icon>mdi-cancel</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('Cancel') + " (" + $t('exit without saving') +")" }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-btn icon large color="primary" v-on="on" @click.stop="saveFeed">
                          <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('Save this feed to TMR')}}</span>
                    </v-tooltip>

                  </v-card-actions>
                </v-card>
              </v-dialog>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small color="primary lighten-2" class="mx-3" @click="editFeedItem(item)">mdi-pencil</v-icon>
          </template>
          <template v-slot:item.manLoad="{ item }">
            <v-icon v-if="item.manLoad" small color="orange darken-1" class="mx-2">mdi-hand-right</v-icon>
          </template>
          <template v-slot:item.index="{ item }">
            {{tmr.feeds.indexOf(item)+1}}
          </template>

        </v-data-table>

        <!--             -->
        <v-card-actions>
          <v-tooltip top v-if="tmrId">
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DeleteTMR">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{this.$i18n.t('Delete TMR') +" "+ tmr.code}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <span class="mx-12 pt-1 subhead primary--text text--lighten-2">{{$t('Dose Weight') + ": " + doseWeight + ' '+$t('Kg')}}</span>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Cancel') + " (" + $t('exit without saving') +")" }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveTMR">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save TMR')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
    name:
        "AddEditTMRDialog",
    props: {
        value: Boolean,
        tmrId: String
    },
    data() {
    return {
      tmr: {},
      lastDoseWeight: 0,
      dialog: false,
      headers: [
        { text: "#", align: "left", value: "index" },
        { text: this.$i18n.t('Code'), align: "left", value: "code" },
        { text: this.$i18n.t('Name'), width: "25%", value: "name" },
        { text: this.$i18n.t('Qty_Kg'), align: "right", value: "qty" },
        { text: this.$i18n.t('Tolerance_Kg'), align: "right", value: "tolerance" },
        { text: this.$i18n.t('Manual'), align: "right", value: "manLoad" },
        { text: " ", value: "action", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        code: "",
        name: "",
        qty: 0,
        tolerance: 0,
        manLoad: false,
      },
      defaultItem: {
        code: "",
        name: "",
        qty: 0,
        tolerance: 0,
        manLoad: false,
      }
    };
  },
  computed: {
    dropdown_feeds() {
      var items = this.$store.getters.getFeedsForDD;
      items.unshift({text: this.$i18n.t('Not a Premix'), value: "" });
      return items;
    },
    dropdown_feeds2() {
      return this.$store.getters.getFeedsForDD;
    },
    modifiedDate() {
      if (this.tmr.modified && typeof this.tmr.modified.getMonth === "function")
        return this.tmr.modified.toLocaleDateString();
      else
        return (new Date("01/01/2000")).toLocaleDateString();

    },
    formTitle () {
      return this.editedIndex === -1 ? this.$i18n.t('Add feed load to TMR') : this.$i18n.t('Edit feed load in TMR') + " " + this.editedItem.code
    },
    doseWeight() {
      return this.$store.getters.getTMRDoseWeight(this.tmr.feeds)
    },
    isNewTmr() {
      return (this.tmr && this.tmr.Id) == null;
    },
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit("input", value);
            this.value = value;
        }
    },
    active: {
      get() {
        return ! this.tmr.inactive
      },
      set(val) {
        if (val == undefined)
          this.tmr.inactive = false;
        else
          this.tmr.inactive = !val;
      }
    },
  },
  watch: {
      dialog (val) {
        val || this.closeFeedEditor()
      },
    },
  methods: {

    CancelDialog() {
      this.tmr = _.cloneDeep(this.$store.getters.getTMR(this.tmrId));
      this.$emit("close");
    },
    SaveTMR() {
      // if (this.tmr.dryMaterial > 1)
      //   this.tmr.dryMaterial /= 100;    //make sure percent is store as a fraction
      if (this.tmrId &&
          this.lastDoseWeight > 0 &&
          Math.abs(this.$store.getters.getTMRDoseWeight(this.tmr.feeds) - this.lastDoseWeight) > 0.01
          ) {
            //dose weight changed need to update version
            this.tmr.version++;
            this.$root.$globalSnackbar(this.$i18n.t('New dose weight, TMR Version updated!'), "info");
        }
      var payload = {Id: this.tmrId, ...this.tmr}
      this.$store.dispatch("saveTMR", payload);
      //this.tmr = _.cloneDeep(this.$store.getters.getTMR(this.tmrId));
      this.$emit("close");
    },
    DeleteTMR() {
      if (this.tmrId) {
        this.$root.$confirm(this.$i18n.t('Delete'), this.$i18n.t('Delete TMR') +" "+ this.tmr.name + "?", { color: "red" }).then((confirm) => {
          if (confirm) {
            this.$store.dispatch("deleteTMR", this.tmrId);
            //this.show=false;
            this.$emit("close");
          }
        });
      }
    },
    fillFeedValues: function(event) {
      if (event) {
        let feed = this.$store.getters.getFeed(event);
        if (feed) {
          this.editedItem.code = feed.code;
          this.editedItem.name = feed.name
          this.editedItem.tolerance = feed.tolerance;
          this.editedItem.manLoad = feed.manLoad;
          const premixTmr = this.$store.getters.getPremixTmr(feed.Id);
          if (premixTmr)
            this.editedItem.qty = premixTmr.doseweight;
          else
            this.editedItem.qty = "";
          this.editedItem.Id = feed.Id;
          this.$nextTick(() =>
            this.$refs.qtyField.focus());
        }

      }
    },
    editFeedItem (item) {
      this.editedIndex = this.tmr.feeds.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.$nextTick(() =>
            this.$refs.qtyField.focus());
    },

    deleteFeedItem () {
      let snackMessage = this.$i18n.t('Feed') + " " + this.tmr.feeds[this.editedIndex].name + " " + this.$i18n.t('removed from TMR')
      this.tmr.feeds.splice(this.editedIndex,1);
      this.$root.$globalSnackbar(snackMessage, "warning");
      this.closeFeedEditor();
    },

    saveFeed () {
      if (this.editedIndex > -1) {
        Object.assign(this.tmr.feeds[this.editedIndex], this.editedItem)
      } else {
        this.tmr.feeds.push(this.editedItem)
      }
      this.closeFeedEditor()
    },

    closeFeedEditor () {
      this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
    },
  },

  mounted: function () {
      document.addEventListener("keydown", (e) => {
        if (this.show && e.keyCode == 27) {
          this.tmr = _.cloneDeep(this.$store.getters.getTMR(this.tmrId));
          this.$emit("close");
        }
      });
      this.tmr = _.cloneDeep(this.$store.getters.getTMR(this.tmrId));
      //this.tmr.feeds = Object.assign([], this.$store.getters.getTMR(this.tmrId).feeds);
      this.lastDoseWeight = this.$store.getters.getTMRDoseWeight(this.tmr.feeds);
    },
}
</script>

<style scoped>
.v-data-table td {
    height: 40px;
}
</style>
